export default {
    ready: (state, getters, rootState, rootGetters) => {
        return false
    }
}
